import post from './post.js';
import get from './get.js';

export default {
	get: ({ session }) => get('json/get', { session }),
	save: ({ session, data }) => post('json/save', { session, data }),
};
